var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-end mb-3"},[_c('TemplateCreateWizard',{on:{"templateCreated":_vm.onTemplateCreated}})],1),_c('TemplateListTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }